
$(document).ready(function () {
    //select all controls
    if (!jQuery(".captcha-main-image")[0]){  
    var elements = document.querySelectorAll('div[tlv-js-control]');

    //iterate thru all found controls
    for (var i = 0; i < elements.length; i++) {
        var elm = elements[i];

        switch ($(elm).attr('tlv-js-control')) {
            //Captcha control
            case "TlvJs.UI.Captcha":
                //alert('found');
                //get object reference
                var cap = TlvJs.UI.Captcha($(elm).attr('id'));
                //get object properties
                var options = $(elm).attr('tlv-js-options');

                setInstanceProps(options, cap);
                //change the protocol (http / https)  
                cap.url = SetClientProtocol(cap.url);
                //init captcha
                cap.initCaptcha();
                //extend jquery with custom property in order to give access to attached 
                //scripting object
                $.prototype.TlvCaptcha = cap;
                //alert(a.ValidateCaptcha());
                break;
            case "TlvJs.UI.FileUploader":

                break;
            default:
                //alert('nothing found');
        }
    }
}
    
});


var TlvJs = {
    UI: {
        Captcha: function (tagId) {
            var cap;
            cap = Captcha(tagId);
            return cap;
        },
        FileUploader: function (options) {
            return FileUploader(options);
        }
    },
    Utils: {

    },
    Navigation: {

    }
};



//util functions

function setInstanceProps(props, instance) {
    props = '{' + props + '}';

    try {
        var jsonProps = JSON.parse(props.replace(/\'/g, '"'));
        for (var pr in jsonProps) {
            instance[pr] = jsonProps[pr];
        }

    } catch (e) {
        alert("Failed to parse tlv-js-options attribute!!! Load failed!");
    }
    //var optionsArray = props.split(',');
    //for (var j = 0; j < optionsArray.length; j++) {
    //    var delimiter = optionsArray[j].indexOf(':');
    //    //cap[url] for instance means cap.url property
    //    if (optionsArray[j].substring(delimiter + 1).indexOf('{') != -1)
    //    {
    //        var obj;
    //        //remove opening {
    //        var subOptions = optionsArray[j].substring(delimiter + 1).substring(optionsArray[j].substring(delimiter + 1).indexOf('{') + 1);
    //        //remove closing }
    //        subOptions = subOptions.substring(0, subOptions.trim().indexOf('}') -1);
    //        var objProps = optionsArray[j].substring(delimiter + 1).split(';');
    //        for (var i = 0; i < objProps.length ; i++) {


    //        }
    //    }
    //    else
    //    {
    //        instance[optionsArray[j].substring(0, delimiter)] = optionsArray[j].substring(delimiter + 1);
    //    }
    //}
}


function SetClientProtocol(sourceUrl) {
    var index = sourceUrl.indexOf("://");
    return window.location.protocol + sourceUrl.substring(index+1);
}
function reloadCaptcha() {
    var elements = document.querySelectorAll('div[tlv-js-control]');

    //iterate thru all found controls
    for (var i = 0; i < elements.length; i++) {
        var elm = elements[i];

        switch ($(elm).attr('tlv-js-control')) {
            //Captcha control
            case "TlvJs.UI.Captcha":
                //alert('found');
                //get object reference
                var cap = TlvJs.UI.Captcha($(elm).attr('id'));
                //get object properties
                var options = $(elm).attr('tlv-js-options');

                setInstanceProps(options, cap);
                //change the protocol (http / https)  
                cap.url = SetClientProtocol(cap.url);
                //init captcha
                cap.initCaptcha();
                //extend jquery with custom property in order to give access to attached 
                //scripting object
                $.prototype.TlvCaptcha = cap;
                //alert(a.ValidateCaptcha());
                break;
            case "TlvJs.UI.FileUploader":

                break;
            default:
                //alert('nothing found');
        }
    }
}

